import { render, staticRenderFns } from "./BestThing.vue?vue&type=template&id=5b4c016a&scoped=true&lang=pug&"
import script from "./BestThing.vue?vue&type=script&lang=js&"
export * from "./BestThing.vue?vue&type=script&lang=js&"
import style0 from "./BestThing.vue?vue&type=style&index=0&id=5b4c016a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4c016a",
  null
  
)

export default component.exports